import { GET_INTERNATIONAL_SALES_CONTRACT_REQUEST, GET_INTERNATIONAL_SALES_CONTRACT_SUCCESS, GET_INTERNATIONAL_SALES_CONTRACT_ERROR } from "./types.js"
import { BASEURL } from "../../constant/config.js"
import axios from "axios";

export const getInternationalSalesContract = (token) => dispatch => {
    dispatch({ type: GET_INTERNATIONAL_SALES_CONTRACT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/InternationalSalesContract`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {

            return dispatch({ type: GET_INTERNATIONAL_SALES_CONTRACT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_INTERNATIONAL_SALES_CONTRACT_ERROR,
                payload: error.response,
            });
        })
}

